import { RadioGroup } from "@headlessui/react";
import React, { ReactNode } from "react";
import { useStore } from "src/stores/Store";
import colors from "src/utils/colors";
import tw from "src/utils/tw";

interface Props {
  value?: string | boolean;
  checked?: Boolean;
  onChange?: (value) => void;
  children: ReactNode;
  disabled?: boolean;
  isPreview?: boolean;
  className?: string;
}

export function InputRadioButton(props: Props) {
  const store = useStore();

  function renderChildren({ checked, disabled }) {
    let borderColor = colors.borderGray;
    let borderHoverColor = store.theme.orgColor;

    if (store.isAdminArea) {
      borderHoverColor = colors.empty;
    }

    if (props.isPreview) {
      borderHoverColor = store.theme.orgOrgColor;
    }

    if (checked) {
      if (props.isPreview) {
        borderColor = store.theme.orgOrgColor;
        borderHoverColor = store.theme.orgOrgColor;
      } else if (store.isAdminArea) {
        borderColor = colors.dark;
        borderHoverColor = colors.dark;
      } else {
        borderColor = store.theme.orgColor;
        borderHoverColor = store.theme.orgColor;
      }
    }
    return (
      <div
        className={tw(
          "-mx-px",
          "cursor-pointer",
          "flex-1",
          "h-11",
          "flex",
          "items-center",
          "justify-center",
          "border",
          "transition",
          "hover:z-10",
          "bg-white",
          checked && "z-20",
          "text-dark",
          "relative",
          disabled && "pointer-events-none opacity-50",
          props.className
        )}
        css={{
          borderColor,
          "&:hover": {
            borderColor: borderHoverColor,
          },
        }}
      >
        <div
          className={tw(
            "absolute",
            "right-4",
            "transition",
            "transform",
            "text-organization",
            checked ? "scale-100" : "scale-0"
          )}
        >
          <i className="far fa-check" />
        </div>
        {props.children}
      </div>
    );
  }

  return (
    <RadioGroup.Option
      // onClick={() => props.onChange(props.value)}
      as={React.Fragment}
      value={props.value}
    >
      {renderChildren}
    </RadioGroup.Option>
  );
}

export function InputRadioButtons(props: Props) {
  return (
    <RadioGroup
      value={props.value}
      onChange={props.onChange}
      className={tw("flex rounded", props.className)}
      css={{
        "& div:first-of-type": {
          borderTopLeftRadius: 4,
          borderBottomLeftRadius: 4,
        },
        "& div:last-of-type": {
          borderTopRightRadius: 4,
          borderBottomRightRadius: 4,
        },
      }}
      disabled={props.disabled}
    >
      {props.children}
    </RadioGroup>
  );
}
